import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { useKey } from 'react-use';

import Modal from 'components/Shared/Modals';
import Button from 'components/Shared/Common/Button';

const formatMessages = intl => ({ fullname }) => ({
    modalTitle: intl.formatMessage({ id: 'modal.kickRoomUser.title' }),
    modalTitleHangUp: intl.formatMessage({ id: 'modal.kickRoomUser.title.hangUp' }),
    modalContent: intl.formatMessage({ id: 'modal.kickRoomUser.content' }, { fullname }),
    buttonCancel: intl.formatMessage({ id: 'global.button.cancel' }),
    buttonKick: intl.formatMessage({ id: 'global.button.confirm' })
});

const KickRoomUser = (props) => {
    const {
        intl,
        onClose,
        fullname = '',
        _room,
        _user,
        isPhoneNumber = false,
        onKick
    } = props;

    const handleKickUser = useCallback(() => {
        onKick(_room, [_user]);
        onClose();
    }, [onKick, onClose, _room, _user]);

    const i18n = formatMessages(intl)({ fullname });

    useKey('Enter', handleKickUser);

    return (
        <Modal
            isOpen
            title={i18n.modalTitle}
            footer={(
                <>
                    <Button
                        color="secondary"
                        onClick={onClose}
                    >
                        {i18n.buttonCancel}
                    </Button>
                    <Button
                        color="error"
                        onClick={handleKickUser}
                    >
                        {i18n.buttonKick}
                    </Button>
                </>
            )}
            onClose={onClose}
        >
            {isPhoneNumber ? i18n.modalTitleHangUp : i18n.modalContent}
        </Modal>
    );
}

KickRoomUser.propTypes = {
    intl: PropTypes.any.isRequired,
    onKick: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    fullname: PropTypes.string,
    _user: PropTypes.string.isRequired,
    _room: PropTypes.string.isRequired,
    isPhoneNumber: PropTypes.string,
};

export default injectIntl(KickRoomUser);
